import { noop } from "lodash";
import type { ProviderRoleChange } from "../types";

// useLivekitRoleChange does nothing as we handle role change on server side
export const useLivekitRoleChange = (): ProviderRoleChange => ({
  hasRoleChangeRequest: false,
  requestedByPeer: null,
  requestRoleChange: () => Promise.resolve(),
  acceptRoleChange: () => Promise.resolve(),
  rejectRoleChange: noop,
});
